export default "__VITE_ASSET__9pkf5yn7__"